import { Link } from "react-router-dom";
import { Logo } from "assets/logo";

const Footer = () => {
    return (
        <footer className="ln-footer wow fadeInUp" data-wow-delay=".15s">
            <div className="ln-footer-widgets">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <div className="ln-widget">
                                <Link to="/" className="ln-footer-logo">
                                    <Logo />
                                </Link>
                                <p className="ln-widget-desc">
                                    Web, mobile, cloud, and AI/LLM integration for
                                    teams that need clear scope, steady
                                    communication, and software they can run in
                                    production.
                                </p>
                                <ul className="ln-widget-socials">
                                    <li>
                                        <a
                                            href="mailto:contact@lnsols.com"
                                            aria-label="Email LN Sols"
                                        >
                                            <i
                                                className="lni lni-envelope"
                                                aria-hidden="true"
                                            />
                                        </a>
                                    </li>
                                    <li>
                                        <Link
                                            to="/contact"
                                            aria-label="Contact LN Sols"
                                        >
                                            <i
                                                className="lni lni-phone"
                                                aria-hidden="true"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/about"
                                            aria-label="About LN Sols"
                                        >
                                            <i
                                                className="lni lni-users"
                                                aria-hidden="true"
                                            />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="/privacy-policy"
                                            aria-label="Privacy policy"
                                        >
                                            <i
                                                className="lni lni-shield"
                                                aria-hidden="true"
                                            />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div className="ln-widget">
                                <h5 className="ln-widget-title">Site</h5>
                                <ul className="ln-widget-links">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/services">Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/about">About</Link>
                                    </li>
                                    <li>
                                        <Link to="/contact">Contact</Link>
                                    </li>
                                    <li>
                                        <Link to="/blog">Blog</Link>
                                    </li>
                                    <li>
                                        <Link to="/case-studies">Case studies</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col">
                            <div className="ln-widget">
                                <h5 className="ln-widget-title">Services</h5>
                                <ul className="ln-widget-links">
                                    <li>
                                        <Link to="/services/web-development">
                                            Web development
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/cloud-solutions">
                                            Cloud solutions
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/mobile-development">
                                            Mobile development
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/data-analytics">
                                            Data analytics
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/ai-integration">
                                            AI &amp; ML integration
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ln-footer-bottom">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <ul className="ln-footer-bottom-left">
                                <li>
                                    <Link to="/privacy-policy">
                                        Privacy policy
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact">Support</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <p className="ln-footer-bottom-right">
                                © {new Date().getFullYear()}{" "}
                                <a
                                    href="https://lnsols.com"
                                    rel="nofollow noopener noreferrer"
                                >
                                    LN Sols
                                </a>
                                . All rights reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
